import React, { Component } from 'react';
import '../css/aluno/style_avatar.css';
class render_avatar_p extends Component {
    render() {

        const foto = {'backgroundImage':`url(${this.props.Foto})`}
      
        return (
             <div className="hexagon-p" style={foto}>
                <div className="hexTop-p"></div>
                <div className="hexBottom-p"></div>
            </div>
        );
    }
}

export default render_avatar_p;


// WEBPACK FOOTER //
// ./src/container/render_avatar_p.js